
<form class="mce-form-section">

    <div class="mce-form-section-title">Branding/Logo</div>

    <div class="mce-form-field-group">
        <mce-image-upload [title]="'Select Logo Image'"
                          [initialImageUrl]="form().initialImageUrl().value()"
                          [maxSize]="512000"
                          [formField]="form().imageData64">

        </mce-image-upload>

    </div>


</form>


